import { render, staticRenderFns } from "./ItemInfoSidesheet.vue?vue&type=template&id=b8d51f4a&scoped=true&"
import script from "./ItemInfoSidesheet.vue?vue&type=script&lang=js&"
export * from "./ItemInfoSidesheet.vue?vue&type=script&lang=js&"
import style0 from "./ItemInfoSidesheet.vue?vue&type=style&index=0&id=b8d51f4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d51f4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8d51f4a')) {
      api.createRecord('b8d51f4a', component.options)
    } else {
      api.reload('b8d51f4a', component.options)
    }
    module.hot.accept("./ItemInfoSidesheet.vue?vue&type=template&id=b8d51f4a&scoped=true&", function () {
      api.rerender('b8d51f4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/inventory/ItemInfoSidesheet.vue"
export default component.exports